// src/components/ErrorMessage.jsx
import PropTypes from 'prop-types';

const ErrorMessage = ({ message }) => {
    return (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative my-4 max-w-md mx-auto" role="alert">
            <span className="block sm:inline">{message}</span>
        </div>
    );
};

ErrorMessage.propTypes = {
    message: PropTypes.string.isRequired,
};

export default ErrorMessage;
